// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PortalTheme from './portal/PortalTheme';
import Home from './portal/Home';
const Dashboard = React.lazy(() => import('./portal/Dashboard'));
const Login = React.lazy(() => import('./portal/Login'));
const AuthCallback = React.lazy(() => import('./portal/Login').then(module => ({ default: module.AuthCallback })));
const Preview = React.lazy(() => import('./portal/Preview'));
const StyleGuides = React.lazy(() => import('./views/style-guides'));





const App = () => {
  return (
    <Router>
        <PortalTheme><React.Suspense fallback={<div className="screen-message" role="status">Loading workspace…</div>}><Routes>
          <Route path="/" element={<Home />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/a/:pid" element={<Preview />} />
          <Route path="/c/:pid" element={<Preview legacyHtml />} />
          <Route path="/style-guide" element={<StyleGuides />} />
          <Route path="*" element={<main className="screen-message"><h1>Page not found</h1><a href="/">Return home</a></main>} />
        </Routes></React.Suspense></PortalTheme>
    </Router>
  );
};

export default App;
